module.exports = require('./dist/InfiniteScroll')



//////////////////
// WEBPACK FOOTER
// ./node_modules/.1.1.4@react-infinite-scroller/index.js
// module id = 1240
// module chunks = 0